import EventEmitter from 'events';
import { permissionAPI, duplicateObject } from './lib';
import LoggerWrapper from '../../modules/logger-wrapper';

const logger = new LoggerWrapper('MEDIA_CORE', 'Permissions', LoggerWrapper.DEBUG);
logger.setRemoteVerbosity(LoggerWrapper.DEBUG);
class Permissions extends EventEmitter {
	constructor() {
		super(arguments);

		this._trackers = {};
		this.promise = null;
		this.permissions = {
			camera: false,
			microphone: false,
		};

		if (permissionAPI) {
			this._trackers = {
				camera: navigator.permissions.query({ name: 'camera' }),
				microphone: navigator.permissions.query({ name: 'microphone' }),
			};
		}

		this._handlePermissionChange = this._handlePermissionChange.bind(this);
		this.initPermissions();
	}

	async initPermissions() {
		const initializing = {};

		this.promise = new Promise((resolve, reject) => {
			initializing.resolve = resolve;
			initializing.reject = reject;
		});

		if (permissionAPI) {
			for (let inputType in this.permissions) {
				const result = await this._trackers[inputType];
				this.permissions[inputType] = result.state === 'granted';
				const onPermissionChange = (ev) => this._handlePermissionChange({ inputType, state: ev.target.state });
				result.addEventListener('change', onPermissionChange);
			}
		} else {
			await this._fallbackCheckPermissions();
		}

		initializing.resolve();
		logger.debug('Current device permissions', this.permissions);
	}

	_handlePermissionChange({ inputType, state }) {
		const previous = duplicateObject(this.permissions);
		this.permissions[inputType] = state === 'granted';
		logger.debug(`Permission in ${inputType} changed to [${state}]`, this.permissions);
		this.emit('permissions:changed', this.permissions, previous);
	}

	async _fallbackCheckPermissions() {
		const deviceList = await navigator.mediaDevices.enumerateDevices();
		const camDevice = deviceList.find((dev) => dev.kind === 'videoinput');
		const micDevice = deviceList.find((dev) => dev.kind === 'audioinput');

		this.permissions.microphone = micDevice ? micDevice.label !== '' : true;
		this.permissions.camera = camDevice ? camDevice.label !== '' : true;
		//this.emit('permissions:changed', this.permissions);
		return this.permissions;
	}

	async getPermissions() {
		if (!permissionAPI) {
			return await this._fallbackCheckPermissions();
		}
		return this.permissions;
	}

	async hasAllPermissions() {
		const p = await this.getPermissions();
		return p.camera && p.microphone;
	}

	async hasSomePermissions() {
		const p = await this.getPermissions();
		return p.camera || p.microphone;
	}

	async requestPermissions(request = { audio: true, video: true }, appConstraints) {
		try {
			// UGLY: Hack to setup right resolution. 4K first call.
			const result = await navigator.mediaDevices.getUserMedia({
				video: request.video ? appConstraints.video : false,
				audio: request.audio ? appConstraints.audio : false,
			});

			result.getTracks().forEach((track) => track.stop());
			result = null;
		} catch (err) {
			logger.debug('Device permission denied.', { errorName: error.name, request });
		} finally {
			if (!permissionAPI) {
				await this._fallbackCheckPermissions();
			}
			return this.permissions;
		}
	}
}

export default Permissions;
